import { Box, Image, Input, Text, Wrap } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import useStateRef from "react-usestateref";
import styles from "./bottom.module.css";
import { CloseButton } from "@chakra-ui/react";
import Attachment from "../../atoms/icons/attachmentIcon.svg";
import RightArrow from "../../atoms/icons/arrowRight.svg";
import Post from "../../atoms/icons/post.svg";
import ToastView from "../../molecules/experiential/ToastView";
import { useState } from "react";
import { createPost, updatePost } from "../../../api/wall";
import {
  isNotEmptyOrNull,
  onlyTagsExist,
  urlString } from
"../../../utils/common-utils";
import ExperientialPost from "../modal/ExperientialPost";
import { useNavigate } from "@remix-run/react";
import { endTask } from "../../../network/LearnApiService";
import { useTutor } from "../../../context/AiTutorContext";
import { useRoot } from "../../../context/RootContext";
import EditableDiv from "../../../pages/ai-tutor/Editor/EditableDiv";
import { v4 as uuidv4 } from "uuid";
import PopupModal from "../Wall/popup-modal/PopupModal";
import { CARD_COLORS } from "../../../utils/wall/wall-constants";

export default function BottomInput({
  expData,
  goBack,
  isEdit,
  isBackClicked,
  isDelete,
  postId,
  isBackClickedPost
}) {
  let initialBlock = [
  {
    index: uuidv4(),
    content: ""
  }];

  const { taskId } = useRoot();
  const [displayToast, setdisplayToast] = useState(false);
  const fileInputRef = useRef(null);
  const [data, setData, dataRef] = useStateRef({});
  const [backUpData, setBackUpData, backUpDataRef] = useStateRef({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [value, setValue] = React.useState("");
  const [backUpValue, setBackUpValue] = React.useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [showPostModal, setShowPostModal] = useState(false);
  const [postItem, setPostItem] = useState({});
  const navigate = useNavigate();
  const [disableInputView, setDisableInputView, disableInputViewRef] =
  useStateRef(false);
  const [postLoader, setPostLoader, postLoaderRef] = useStateRef(false);
  const [blocks, setBlocks, blocksRef] = useStateRef(initialBlock);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [uploadConfirmed, setUploadConfirmed] = useState(false);

  const fileTypeValidation = {
    0: [".doc", ".docx", ".pdf", ".xls", ".xlsx", ".txt", ".ppt", ".pptx"], // Worksheet (including presentation files)
    1: [".jpg", ".jpeg", ".png", ".bmp", ".webp"] // Images
  };

  useEffect(() => {
    if (isEdit === true && isDelete === false) {
      setValue(backUpValue);
      setData(backUpDataRef.current);
      setBlocks([
      {
        index: uuidv4(),
        content: postItem?.content || ""
      }]
      );
    }
    if (isDelete === true) {
      setValue("");
      setData({});
    }
  }, [isEdit, isDelete]);

  useEffect(() => {
    if (isBackClicked) {
      setDisableInputView(true);
    } else {
      setDisableInputView(false);
    }
  }, [isBackClicked]);

  useEffect(() => {
    if (blocksRef?.current?.length > 0) {
      let enterdText = fetchFinalContent();
      setValue(enterdText);
    }
  }, [blocksRef?.current]);

  const fetchFinalContent = () => {
    return blocksRef.current.
    map((item) => (item.mathText ? item.mathText : "") + item.content).
    join(" ");
  };

  const handleUpdateText = (type, value, index) => {
    let existing = [...blocksRef.current];
    existing = existing.map((item) => {
      if (item.index === index) {
        return {
          ...item,
          [type === "math" ? "mathText" : "content"]:
          type === "math" ? ` \\(${value}\\) ` : value
        };
      } else {
        return item;
      }
    });
    setBlocks(existing);
  };

  const validateFileTypes = (files, selectedIndex) => {
    const validExtensions = fileTypeValidation[selectedIndex];
    return files.filter((file) =>
    validExtensions.some((ext) => file.name.toLowerCase().endsWith(ext))
    );
  };

  const countFilesByType = (files, selectedIndex) => {
    return files.filter((file) =>
    fileTypeValidation[selectedIndex].some((ext) =>
    file.name.toLowerCase().endsWith(ext)
    )
    ).length;
  };

  const handleFilesChange = (event) => {
    const newFiles = Array.from(event.target.files);
    const validFiles = validateFileTypes(newFiles, selectedIndex);

    if (selectedIndex === 1) {
      const currentImageCount = countFilesByType(
        dataRef.current?.files || [],
        1
      );
      const newImageCount = validFiles.length;

      if (currentImageCount + newImageCount > 2) {
        setToastMessage("You can upload a maximum of 2 images.");
        setdisplayToast(true);
        return;
      }
    }

    if (validFiles.length === 0) {
      setToastMessage(
        `Please upload valid file types for the selected section.`
      );
      setdisplayToast(true);
      return;
    }

    const newFileData = validFiles.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      name: file.name,
      type: file.type,
      mimeType: file.type,
      size: file.size
    }));

    setData({
      ...data,
      files: [
      ...(dataRef.current?.files ?? []),
      ...newFileData.map((f) => f.file)],

      fileURLs: [
      ...(dataRef.current?.fileURLs ?? []),
      ...newFileData.map((f) => ({
        url: f.url,
        name: f.name,
        type: f.type,
        mimeType: f.mimeType,
        size: f.size
      }))]

    });
    // console.log(dataRef.current);
  };

  const handlePost = () => {
    setUploadConfirmed(false);
    const imageCount = countFilesByType(dataRef.current?.files || [], 1);

    if (
    !isNotEmptyOrNull(dataRef.current?.files) ||
    dataRef.current?.files?.length === 0)
    {
      setToastMessage("Please attach at least one file");
      setdisplayToast(true);
    } else if (imageCount > 2) {
      setToastMessage("You can upload a maximum of 2 images.");
      setdisplayToast(true);
    } else if (!isNotEmptyOrNull(value) || onlyTagsExist(value)) {
      setToastMessage("Please enter description to complete the experiential");
      setdisplayToast(true);
    } else {
      setPostLoader(true);
      setShowLoadingModal(true);
      const randomColor = CARD_COLORS[Math.floor(Math.random() * CARD_COLORS.length)];
      let inputData = {
        description: value,
        fileURLs: dataRef.current?.fileURLs || [],
        files: dataRef.current?.files || [],
        links: [],
        newLink: "",
        title: expData?.activityInfo?.name || "",
        color: randomColor
      };
      setBlocks(initialBlock);
      savePost(inputData, expData?.id);
    }
  };


  const savePost = async (inputData, activityId) => {
    try {
      if (isEdit) {
        let { success, data } = await updatePost(
          inputData,
          activityId,
          postItem?.id,
          "submitted",
          isBackClickedPost
        );
        if (success) {
          setUploadConfirmed(true);
          isEdit = false;
          setBackUpValue(value);
          setBackUpData(dataRef.current);
          setValue("");
          setData({});
          setPostItem(data);
          setShowPostModal(true);
          // if (isNotEmptyOrNull(taskId)) {
          //   endTask(taskId, data?.id.toString());
          // }
        } else {
          setShowLoadingModal(false);
        }
      } else {
        let { success, data } = await updatePost(inputData, activityId, postId, "submitted", isBackClickedPost);
        if (success) {
          setUploadConfirmed(true);
          setBackUpValue(value);
          setBackUpData(dataRef.current);
          setValue("");
          setData({});
          setPostItem(data);
          setShowPostModal(true);
          // if (isNotEmptyOrNull(taskId)) {
          //   endTask(taskId, data?.id.toString());
          // }
        } else {
          setShowLoadingModal(false);
        }
      }
    } finally {
      setPostLoader(false);
    }
  };

  const handleRemoveItem = (selectedIndex) => {
    let filteredItems = [];
    let filteredFileUrls = [];
    dataRef.current?.files?.map((item, index) => {
      if (selectedIndex !== index) {
        filteredItems = [...filteredItems, item];
      }
    });
    dataRef.current?.fileURLs?.map((item, index) => {
      if (selectedIndex !== index) {
        filteredFileUrls = [...filteredFileUrls, item];
      }
    });

    setData({ ...data, files: filteredItems, fileURLs: filteredFileUrls });
    // console.log(dataRef?.current);
  };
  const handleToastClose = () => {
    setdisplayToast(false);
  };

  const closeModal = () => {
    goBack(value, postItem);
    setShowPostModal(false);
  };

  const goToWall = () => {
    navigate(`${urlString}/wall/my-class-wall`);
    setShowPostModal(false);
  };

  return (
    <div>
      {displayToast &&
      <ToastView description={toastMessage} handleClose={handleToastClose} />
      }
      {!isBackClicked &&
      <div
        className={styles["container-input"]}
        style={{
          pointerEvents: disableInputViewRef.current ? "none" : "auto"
        }}>

          <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            maxWidth: "100%"
          }}>

            {dataRef.current?.files?.length > 0 &&
          <div className={styles["attachments-container"]}>
                {dataRef.current &&
            dataRef.current?.files?.map((item, index) =>
            <div
              key={index}
              className={styles["container-attachement"]}>

                      <Text
                cursor={"pointer"}
                fontFamily={"Poppins, Text-base/Regular"}
                fontWeight={400}
                fontSize={"16px"}
                lineHeight={"24px"}
                noOfLines={2}
                textColor={"#5F4DC7"}>

                        {item.name}
                      </Text>
                      <CloseButton
                color={"#5F4DC7"}
                onClick={() => {
                  handleRemoveItem(index);
                }} />

                    </div>
            )}
              </div>
          }
          </div>

          {/* <Input
          variant="unstyled"
          placeholder="Briefly describe your activity here. Refer the reference material for instructions"
          value={value}
          onChange={handleChange}
          /> */}
          {blocksRef?.current?.map((item, idx) => {
          return (
            <Box
              w={"100%"}
              display={"flex"}
              alignItems={"center"}
              flexWrap={"wrap"}
              overflowY={"auto"}>

                {item.content !== undefined &&
              <EditableDiv
                content={item.content}
                // setContent={handleChange}
                setContent={(val) =>
                handleUpdateText("content", val, item?.index)
                }
                index={idx}
                isDisable={false}
                isExperiential={true} />

              }
              </Box>);

        })}
          <div className={styles["bottomContainer"]}>
            <div className={styles["attachments-container"]}>
              <div
              className={styles["upload-box"]}
              onClick={() => {
                setSelectedIndex(0);
                fileInputRef.current?.click();
              }}>

                <Image
                cursor={"pointer"}
                w={"16px"}
                h={"16px"}
                src={Attachment}>
              </Image>
                <Text
                cursor={"pointer"}
                fontFamily={"Poppins, Text-lg/Regular"}
                fontWeight={400}
                fontSize={"12px"}
                lineHeight={"18px"}
                marginBottom={"16px"}
                textColor={"#21146D"}>

                  Presentation/PDF
                </Text>
                <Image
                cursor={"pointer"}
                w={"16px"}
                h={"16px"}
                src={RightArrow}>
              </Image>
              </div>
              <div
              className={styles["upload-box"]}
              onClick={() => {
                setSelectedIndex(1);
                fileInputRef.current?.click();
              }}>

                <Image
                cursor={"pointer"}
                w={"16px"}
                h={"16px"}
                src={Attachment}>
              </Image>
                <Text
                cursor={"pointer"}
                fontFamily={"Poppins, Text-lg/Regular"}
                fontWeight={400}
                fontSize={"12px"}
                lineHeight={"18px"}
                marginBottom={"16px"}
                textColor={"#21146D"}>

                  Images
                </Text>
                <Image
                cursor={"pointer"}
                w={"16px"}
                h={"16px"}
                src={RightArrow}>
              </Image>
              </div>
            </div>
            <div className={styles["post-container"]}>
              <Image
              cursor={"pointer"}
              w={"91px"}
              h={"37px"}
              src={Post}
              onClick={handlePost}>
            </Image>
            </div>
          </div>

          <input
          ref={fileInputRef}
          type="file"
          multiple
          style={{ display: "none" }}
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.msword,.jpg,.jpeg,.png,.bmp,.webp"
          onChange={handleFilesChange} />

        </div>
      }

      {showPostModal && !showLoadingModal &&
      <ExperientialPost
        size={"full"}
        item={postItem}
        itemTitle={expData?.activityInfo?.name || ""}
        goBack={closeModal}
        goToWall={goToWall} />

      }
      {showLoadingModal &&
      <PopupModal
        isOpen={showLoadingModal}
        handleClose={() => setShowLoadingModal(false)}
        type="upload"
        isLoading={true}
        uploadConfirmed={uploadConfirmed} />

      }
    </div>);

}